import { render, staticRenderFns } from "./TagArticleState.vue?vue&type=template&id=4a872d92"
import script from "./TagArticleState.vue?vue&type=script&lang=js"
export * from "./TagArticleState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports